import { useAuthenticated } from "../../authn";

/**
 * Permission hook for user management features.
 *
 * Privilege hierarchy (highest → lowest):
 *   AgenticProvisioner > user_admin > users_readonly
 *
 * - `canView`: user has at least `users_readonly` privilege (or higher)
 * - `canEdit`: user has at least `user_admin` privilege (or provisioner)
 */
export function useUserManagementPermissions() {
  const auth = useAuthenticated();

  const roles =
    auth.state === "authenticated" ? auth.roles : [];

  const isProvisioner = roles.includes("AgenticProvisioner");
  const isUserAdmin = roles.includes("user_admin");
  const isUsersReadonly = roles.includes("users_readonly");

  const canEdit = isProvisioner || isUserAdmin;
  const canView = canEdit || isUsersReadonly;

  return { canView, canEdit, isProvisioner, isUserAdmin, isUsersReadonly };
}
